import React, { useCallback, useMemo, useState } from "react";
import HistoricNames, { AddHistoricNameModal } from "../HistoricalNames";

import { Button } from "antd";
import dayjs from "dayjs";
import { PermissionNames } from "~enums/permissions";
import { useUpdatePerson } from "~pages/Persons/PersonProfile/hooks/useUpdatePerson.js";

const NameComponent = ({ value }) => {
  return <>{value}</>;
};

const EditButton = ({ historicalNames, row, handleUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <AddHistoricNameModal
        historicalNames={historicalNames}
        fetchData={() => {}}
        defaultName={row.nameFullLocal}
        defaultStartDate={dayjs(row.dateStart)}
        defaultEndDate={dayjs(row.dateEnd)}
        isAddModalOpen={isModalOpen}
        setIsAddModalOpen={setIsModalOpen}
        isEditMode={true}
        handleUpdate={handleUpdate}
        modalTitle={"personname"}
      />
      <Button
        onClick={() => setIsModalOpen(true)}
        type={"text"}
        size={"small"}
        icon={<i className="fas fa-pen-to-square" />}
      />
    </>
  );
};

const columns = (historicalNames, handleUpdate) => [
  {
    title: "Person Name",
    dataIndex: "nameFullLocal",
    key: "nameFullLocal",
    render: (value) => <NameComponent value={value} />,
  },
  {
    title: "Start Date",
    dataIndex: "dateStart",
    width: 100,
    key: "dateStart",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    title: "End Date",
    dataIndex: "dateEnd",
    width: 100,
    key: "dateEnd",
    render: (value) => <div>{dayjs(value).format("DD-MM-YYYY")}</div>,
  },
  {
    align: "right",
    width: 50,
    render: (_, row) => (
      <EditButton historicalNames={historicalNames} fetchData={() => {}} row={row} handleUpdate={handleUpdate} />
    ),
  },
];

const PersonHistoricNames = ({ data, personId }) => {
  const { mutate: updateFn } = useUpdatePerson(personId);

  const handleUpdate = useCallback(
    async (value, isEditMode, defaultValue) => {
      const historicalNames = data.historicalNames || [];
      let updated = [];
      if (!isEditMode) {
        updated = [
          ...historicalNames,
          {
            nameFullLocal: value.nameFullLocal,
            dateStart: value.dateStart,
            dateEnd: value.dateEnd,
          },
        ];
      } else {
        updated = historicalNames.map((item) =>
          item.nameFullLocal === defaultValue.defaultName &&
          dayjs(item.dateStart).isSame(defaultValue.defaultStartDate) &&
          dayjs(item.dateEnd).isSame(defaultValue.defaultEndDate)
            ? {
                nameFullLocal: value.nameFullLocal,
                dateStart: value.dateStart,
                dateEnd: value.dateEnd,
              }
            : item,
        );
      }
      updateFn({ historicalNames: updated });
    },
    [data?.historicalNames, updateFn],
  );

  const tableColumns = useMemo(() => {
    return columns(data.historicalNames, handleUpdate);
  }, [handleUpdate, data.historicalNames]);

  return (
    <>
      <HistoricNames
        historicalNames={data?.historicalNames}
        fetchData={() => {}}
        columns={tableColumns}
        handleUpdate={handleUpdate}
        modalTitle={"personname"}
        permissionName={PermissionNames.PERSON}
      />
    </>
  );
};

export default PersonHistoricNames;
